export var SnackMessage;
(function (SnackMessage) {
    SnackMessage["success"] = "SNACKBAR_SUCCESS_MESSAGE";
    SnackMessage["error"] = "SNACKBAR_ERROR_MESSAGE";
})(SnackMessage || (SnackMessage = {}));
export var SnackVariant;
(function (SnackVariant) {
    SnackVariant["success"] = "success";
    SnackVariant["info"] = "info";
    SnackVariant["warning"] = "warning";
    SnackVariant["error"] = "error";
})(SnackVariant || (SnackVariant = {}));
export const DEFAULT_ALERT_TITLES = {
    success: 'Success',
    info: 'Info',
    warning: 'Warning notice',
    error: "Error - We couldn't make that change",
};
export const DEFAULT_ALERT_AUTO_HIDE_DURATION = 5000; // ms
export var SnackE2ELocator;
(function (SnackE2ELocator) {
    SnackE2ELocator["container"] = "snack-container";
    SnackE2ELocator["title"] = "snack-title";
    SnackE2ELocator["message"] = "snack-message";
})(SnackE2ELocator || (SnackE2ELocator = {}));
//# sourceMappingURL=snackbar.js.map